import { useEffect, useState } from "react";
import { api, themeColor } from "../../../..";
import Checkbox from "../../../../Components/Checkbox/Checkbox";
import { toast } from 'react-toastify';
import DropDown from "../../../../Components/DropDown/DropDown";
import { useTranslation } from "react-i18next";
import { ShowConfirmPopUp } from "../../../../Components/Popup/Popup";

let unique = -1;

const Item = (props: any) => {
	const [ isUsed, setIsUsed ] = useState([]);
	const [ isChecked, setIsChecked ] = useState(props.cfc.state === '1');
	const [ dropdownValActive, setDropDownValActive ] = useState(props.cfc.pbx_soundfile_id_on);
	const [ dropdownValInactive, setDropDownValInactive ] = useState(props.cfc.pbx_soundfile_id_off);
	const { t } = useTranslation();

	useEffect(() => {
		const a: any = [];
		const user = api.getUser();

		if(api.accessToken && user) {
			api.calls.company.pbx.isUsed.read(user.pbx_company_id, props.cfc.src_pbx_destination_id)
			.then((r: any) => {
				for(const t in r.data) {
					for(const tt in r.data[t]) {
						a.push(<span key={unique--}>{`${t}: ${r.data[t][tt].name}`}</span>);
						//a.push(<br />);
					}
				}

				setIsUsed(a);
			})
		}
		// eslint-disable-next-line
	}, [])

	const changeOptionActive = (event:any) => {
		const prev = dropdownValActive;
		setDropDownValActive(event);

		ShowConfirmPopUp(t('are_you_sure'),
			(r:any) => {
				if(r) {
					api.calls.cfc.update(props.cfc.id, {
						pbx_soundfile_id_on: event.value,
						state: undefined,
						pbx_soundfile_id_off: null
					})
					.then((r: any) => {
						if(r.status === 200) {
							toast.success(t('cfc_active_successfully_changed'));
						} else {
							toast.error(t('something_went_wrong_please_try_again'));
							setDropDownValActive(prev);
						}
					});
				} else {
					setDropDownValActive(prev);
				}
			},
			themeColor
		)
	}

	const changeOptionInactive = (event:any) => {
		const prev = dropdownValInactive;
		setDropDownValInactive(event);

		ShowConfirmPopUp(t('are_you_sure'),
			(r:any) => {
				if(r) {
					api.calls.cfc.update(props.cfc.id, {
						pbx_soundfile_id_off: event.value,
						state: undefined,
						pbx_soundfile_id_on: null
					})
					.then((r: any) => {
						if(r.status === 200) {
							toast.success(t('cfc_inactive_successfully_changed'));
						} else {
							toast.error(t('something_went_wrong_please_try_again'));
						}
					});
				} else {
					setDropDownValInactive(prev);
				}
			},
			themeColor
		)
	}

	const toggleState = () => {
		const cfcState = !isChecked;

		ShowConfirmPopUp(t('are_you_sure'),
			(r:any) => {
				if(r) {
					api.calls.cfc.update(props.cfc.id, {
						state: cfcState === true ? '1' : '0',
						pbx_soundfile_id_on: null,
						pbx_soundfile_id_off: null
					})
					.then((r: any) => {
						if(r.status === 200) {
							toast.success(t('cfc_state_successfully_changed'));
							setIsChecked(isChecked ? false : true)
						} else {
							toast.error(t('something_went_wrong_please_try_again'));
							setIsChecked(false)
						}
					});
				}
			},
			themeColor
		)
	}

	return <tr key={unique--}>
		<td>
			<Checkbox
				name="status"
				controlled={true}
				checked={isChecked}
				onClick={toggleState}
			/>
		</td>
		<td>{props.cfc.name}</td>
		<td>
			{
				isUsed
			}
		</td>
		<td>
		{
			!props.isEdit ?
				props.cfc.pbx_soundfile_id_on === null
					?
						<span>{t('change_in_portal')}</span>
					:
						<DropDown
							disabled={true}
							value={dropdownValActive}
							options={props.soundOptions}
							placeholder={t('change_in_portal')}
						/>
			:
				props.cfc.pbx_soundfile_id_on !== null
				?
					<DropDown
						disabled={props.cfc.pbx_soundfile_id_on === null ? true : ''}
						value={dropdownValActive}
						options={props.soundOptions}
						placeholder={t('change_in_portal')}
						onChange={(event:any) => {
							changeOptionActive(event);
						}}
					/>
				:
					<span>{t('change_in_portal')}</span>
		}
		</td>
		<td>
			{
				!props.isEdit ?
					props.cfc.pbx_soundfile_id_off === null
						?
							<span>{t('change_in_portal')}</span>
						:
							<DropDown
								disabled={true}
								value={dropdownValInactive}
								options={props.soundOptions}
								placeholder={t('change_in_portal')}
							/>
				:
					props.cfc.pbx_soundfile_id_off !== null
					?
						<DropDown
							disabled={props.cfc.pbx_soundfile_id_off === null ? true : ''}
							value={dropdownValInactive}
							options={props.soundOptions}
							placeholder={t('change_in_portal')}
							onChange={(event:any) => {
								changeOptionInactive(event);
							}}
						/>
					:
						<span>{t('change_in_portal')}</span>
			}
		</td>
	</tr>
}

export default Item;
